module.exports = __webpack_public_path__ + "img/ios.e77028d2.svg";